import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameScrollComponent } from '../components/shared/custom-scrolls/game-scroll.component.html/game-scroll.component';



@NgModule({
  declarations: [GameScrollComponent],
  exports: [GameScrollComponent],
  imports: [
    CommonModule
  ]
})
export class SharedModule { }
